import { FlexContainer, Show } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getHomepageData } from '../../store/homepage/selectors';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import RosBottomMpu from '../adverts/ros-bottom-mpu';
import Matches from '../homepage/matches/matches';
import SidebarTable from './sidebar-table';

const SidebarMatches = styled.div`
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  margin-bottom: 24px;
`;

const Sidebar = ({ articleId, club, homepage, teamId }) => {
  const fixtures = Object.values(homepage?.fixturesBySection || {})[0];
  const results = Object.values(homepage?.resultsBySection || {})[0];
  let table = null;
  if (homepage?.tablesByTeam?.length > 0) {
    table =
      homepage.tablesByTeam.find((team) => team.teamId === teamId) || homepage.tablesByTeam[0];
  }

  return (
    <FlexContainer
      flexDirection="column"
      style={{ gap: '24px', width: '100%' }}
      alignItems="center"
    >
      <RosBottomMpu uid={articleId ? articleId.toString() : null} />
      <Show minWidth="fullHeader" style={{ width: '100%' }} component="div">
        {fixtures && fixtures.length > 0 && (
          <SidebarMatches>
            <Matches
              matches={fixtures.slice(0, 3)}
              club={club}
              type="fixture"
              title="Upcoming Matches"
              isMobile
              showBorder
            />
          </SidebarMatches>
        )}
        {results && results.length > 0 && (
          <SidebarMatches>
            <Matches
              matches={results.slice(0, 3)}
              club={club}
              type="result"
              title="Recent Results"
              isMobile
              showBorder
            />
          </SidebarMatches>
        )}
        {table && <SidebarTable data={table} club={club} />}
      </Show>
    </FlexContainer>
  );
};

Sidebar.propTypes = {
  articleId: PropTypes.number,
  club: CLUB_PROP_TYPES.isRequired,
  homepage: PropTypes.shape(),
  teamId: PropTypes.number,
};

Sidebar.defaultProps = {
  articleId: null,
  homepage: null,
  teamId: null,
};

const mapStateToProps = (state, ownProps) => ({
  homepage: getHomepageData(state, ownProps.club.id),
});

export default connect(mapStateToProps)(Sidebar);
